const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAssignPermission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.998 0C3.588 0 0 3.588 0 7.998s3.588 7.998 7.998 7.998 7.998-3.588 7.998-7.998S12.408 0 7.998 0Zm0 14.707a6.717 6.717 0 0 1-6.709-6.709c0-3.7 3.01-6.709 6.709-6.709a6.717 6.717 0 0 1 6.709 6.709 6.717 6.717 0 0 1-6.709 6.709Zm2.549-9.259L6.814 9.181 5.448 7.815a.643.643 0 1 0-.911.911l1.822 1.822a.643.643 0 0 0 .911 0l4.189-4.189a.643.643 0 1 0-.912-.911Z",
    style: {
      fill: "#6b6b6b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssignPermission);
export default __webpack_public_path__ + "static/media/ic-assign-permission.8c47f920c74a08c3d2e808b2edd0bed6.svg";
export { ForwardRef as ReactComponent };